/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LaunchIcon = ({ width = 24, height = 24, hidden = false, title = 'Launch' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.978.377A34.727 34.727 0 0 0 9.586 21.99a.522.522 0 0 0 .125.545l3.752 3.751a.522.522 0 0 0 .541.127A34.428 34.428 0 0 0 35.619 1.018a.544.544 0 0 0-.641-.641ZM7.8 19.148H.9a.524.524 0 0 1-.46-.783C2.021 15.609 7.92 6.52 16.848 6.52 14.776 8.591 7.962 17.569 7.8 19.148ZM16.848 28.2v6.908a.524.524 0 0 0 .779.461c2.752-1.554 11.849-7.376 11.849-16.419-2.076 2.07-11.05 8.884-12.628 9.05Z"
    />
  </svg>`;
};
